export default __webpack_public_path__ + "static/business-monitor-b68b53a4000ef1d6a5989377ee728e11.png";